<div class="swiper-container-wrapper" [class.fullscreen]="isFullscreen">
  <button *ngIf="isFullscreen" class="close-button" (click)="toggleFullscreen()">×</button>
  <swiper-container
    #swiperElement
    [slides-per-view]="1"
    [space-between]="10"
    [navigation]="true"
    [pagination]="{ clickable: true }"
    (swiperactiveindexchange)="setSwiperIndex($event)"
  >
    <swiper-slide *ngFor="let image of galleryImages">
      <div class="swiper-zoom-container">
        <div *ngIf="!isFullscreen" style="width: 100%">
          <div style="display: flex; flex-direction: column; align-items: center">
            <div class="background-blur" [ngStyle]="{ 'background-image': 'url(' + image.big + ')' }"></div>

            <img *ngIf="!isFullscreen" [src]="image.big" [alt]="image.description" (click)="toggleFullscreen()" />
          </div>
          <div class="swiper-image-description" *ngIf="image.description && image.description.length > 1">
            <p>{{ image.description }}</p>
          </div>
        </div>
        <div *ngIf="isFullscreen">
          <div class="background-blur" [ngStyle]="{ 'background-image': 'url(' + image.big + ')' }"></div>

          <img *ngIf="!isFullscreen" [src]="image.big" [alt]="image.description" (click)="toggleFullscreen()" />
        </div>

        <div class="image-zoom-container" fullscreen overflow-scroll="true" *ngIf="isFullscreen">
          <div direction="xy" style="width: 100%; height: 100%">
            <img
              [src]="image.big"
              [alt]="image.description"
              style="width: 100%; height: auto"
              class="zoomable-image"
              (load)="initHammer()"
            />
          </div>
        </div>
      </div>
    </swiper-slide>
  </swiper-container>
</div>

<div class="thumbnail-preview">
  <swiper-container
    #thumbnailSwiper
    [slidesPerView]="5"
    [spaceBetween]="5"
    [navigation]="true"
    (swiperactiveindexchange)="syncMainSwiper($event)"
  >
    <swiper-slide class="thumb" *ngFor="let image of galleryImages; index as i">
      <img
        [class.active]="i === activeIndex"
        [src]="image.thumbnail ? image.thumbnail : image.small"
        (click)="swipeTo(i)"
      />
    </swiper-slide>
  </swiper-container>
</div>
